export default{name:"elementsmenu",props:["isVisible","configurator","elements"],methods:{emitElementClick:function emitElementClick(element,index){this.$emit("elementclick",element,index)},emitClone:function emitClone(){this.$emit("clone")},emitConfirm:function emitConfirm(){this.$emit("confirm")}},computed:{compIsVisible:function compIsVisible(){return this.isVisible},compElements:function compElements(){return this.elements}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/ElementsMenu.vue
// module id = 248
// module chunks = 0